
















import { Component, Vue, Prop } from 'vue-property-decorator'

interface ErrorsObj {
  [key: string]: boolean|string
}

@Component({
  name: 'SettingsInput'
})
export default class SettingsInput extends Vue {
  @Prop({ required: true }) value!: string
  @Prop({ required: true }) typeContent!: string
  @Prop({ required: true }) section!: string
  @Prop({ required: true }) errors!: ErrorsObj
  @Prop({ default: false }) disableautocomplete!: boolean
  @Prop({ default: '' }) placeholder!: string

  showPassword: boolean = false

  get getTypeContent () {
    return this.typeContent === 'text' || this.showPassword
      ? 'text'
      : 'password'
  }

  get showError () {
    return !!this.errors[this.section]
  }

  get cursorType () {
    return this.section === 'workspaceName'
      ? { cursor: 'not-allowed' }
      : { cursor: 'inherit' }
  }

  get autocomplete () {
    return this.disableautocomplete ? 'new-password' : 'on'
  }

  updateValue (value: string) {
    this.$emit('input', value)
  }
}
